// extracted by mini-css-extract-plugin
module.exports = {"container":"impersonate_container__tDOtw","text":"impersonate_text__ji_P7","button":"impersonate_button__PszFN","fade-in":"impersonate_fade-in__Ggs7P"};